(() => {
  window.addEventListener("pageshow", () => {
    // Keep cart UI honest after browser back/forward cache restores an older page.
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  });
})();
